import { IModoDesactivado } from 'modelos/src';
import { estadoHtml } from './tabla/celdas';

/**
 * Vigencia real del modo desactivado: flag activo y (permanente,
 * sin fecha de fin, o fecha de fin futura).
 */
export function isModoDesactivadoActivo(md?: IModoDesactivado): boolean {
  if (!md?.dispositivoDesactivado) return false;
  if (md.permanente) return true;
  if (!md.hasta) return true;
  return new Date(md.hasta) > new Date();
}

/** Estado "Desactivado" para columnas `row.html` (ver GUIA_ESTETICA_LISTADOS) */
export function badgeDesactivadoHtml(label = 'Desactivado'): string {
  return estadoHtml({ texto: label, tono: 'neutro', icono: 'do_not_disturb_on' });
}
